import React, {FC, useEffect, useState} from 'react'

const StatusMessage: FC<any> = () => {

	const [message, setMessage] = useState(null)

	let mess :any = localStorage.getItem("message")
	
	if(mess && !message){
		setMessage(mess)
		
		setTimeout(function(){
			localStorage.removeItem("message")
			setMessage(null)
		}, 3000)
	}
	
	return(
		<>
			{(message) &&
				<div className="alert alert-success alert-dismissible fade show" role="alert">
					{message}
					<button type="button" onClick={()=>{
						localStorage.removeItem("message")
						setMessage(null)
					}} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
				</div>
			}
		</>
	)
}

export {StatusMessage}
